import { nanoid } from '@reduxjs/toolkit';

export const migrations = {
    // numbers indicate the new version
    1: (state) => {
        // migration to keep only device state
        return {
            device: state.device
        }
    },
    // 2: (state) => {
    //     const classId = nanoid();
    //     const { students: { data: oldStudents = [] } } = state;
    //     // only migrate if there were students before
    //     if(!oldStudents.length) return;

    //     const classes = [{ id: classId, name: 'Groep zonder naam' }];
    //     const newState = {
    //         ...state,
    //         classes,
    //         students: oldStudents,
    //     }
    //     return newState;
    // },
}